<div class="row">
  <div class="p-1" [ngClass]="isCollapsed ? 'col-3' : 'col-12'">
    <div class="card mb-2">
      <div class="card-header">
        <span class="client-header-content">Wealth Clients
          <mdb-badge class="badge-wealth-primary" *ngIf="filterableClients.length > 0">{{ getClientStateLabel() }}: {{ filterableClients.length }}</mdb-badge>
        </span>
        <div (click)="onGridCollapse()">
          <ng-container *ngIf="!isCollapsed"><span class="fas fa-angle-double-left"></span></ng-container>
          <ng-container *ngIf="isCollapsed"><span class="fas fa-angle-double-right"></span></ng-container>
        </div>
      </div>

      <div class="card-body my-auto" *ngIf="loadingClientList">
        <app-loading [busy]="loadingClientList" [busyText]="'Loading clients...'"></app-loading>
      </div>

      <div class="card-body my-auto d-sm-flex" *ngIf="!loadingClientList">
        <div class="table-responsive">
          <table class="table" mdbTable hover="true" small="true">
            <thead>
              <tr>
                <th>
                  <div class="md-form">
                    <input [(ngModel)]="searchText" mdbInput name="searchText" type="search" placeholder="Search" style="font-size: small;" />
                  </div>
                </th>
                <th *ngIf="!isCollapsed">
                  <div class="md-form">
                    <select
                      class="md-form form-control browser-default"
                      style="font-size: small"
                      id="clientState"
                      [(ngModel)]="selectedClientState"
                      placeholder="State"
                      (change)="onStateFilterChange()"
                    >
                      <option *ngFor="let option of clientStateOptions" [ngValue]="option.value">
                        {{ option.label }}
                      </option>
                    </select>
                    <label for="clientState" class="active">Filter Client State</label>
                  </div>
                </th>
              </tr>
              <tr class="table-header">
                <th class="sortable" [appSort]="filterableClients" data-name="fullName">Client</th>
                <ng-container *ngIf="!isCollapsed">
                  <th>Last Completed Step</th>
                  <th>Last Note</th>
                  <th class="sortable" [appSort]="filterableClients" data-order="desc" data-name="lastUpdatedDateTime" data-type="date">Last Updated</th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let clientInfo of filterableClients | filter: searchText">
                <tr (click)="onClientSelect(clientInfo.userId)" [ngClass]="{ 'selected-client': clientInfo.userId === selectedClientId }">
                  <td>{{ clientInfo.fullName }}</td>
                  <ng-container *ngIf="!isCollapsed">
                    <td class="text-muted small">{{ clientInfo.lastCompletedStepDescription }}</td>
                    <td>{{ clientInfo.lastNote }}</td>
                    <td>{{ clientInfo.lastUpdatedDateTime | date: "dd MMM yyyy" }}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="col-9">
    <div class="row">
      <div class="col-12">
        <ng-container *ngIf="isCollapsed && selectedClientId == null">
          <div class="col-12 p-1">
            <div class="card">
              <div class="card-header my-auto">Please select a client to continue onboarding them</div>
            </div>
          </div>
        </ng-container>
        
        <ng-container *ngIf="infoLoading">
          <div class="card-body my-auto">
            <app-loading [busy]="infoLoading" [busyText]="'Loading client...'"></app-loading>
          </div>
        </ng-container>

        <ng-container *ngIf="!infoLoading">
          <ng-container *ngIf="selectedClientId != null">
            <div class="row">
              <div class="col-12 p-1">
                <div class="card">
                  <div class="card-header my-auto d-sm-flex" style="justify-content: space-between">
                    <div>
                      <strong>{{ onboardingClient.fullName }}</strong> ({{ onboardingClient.userId }})
                      <mdb-badge *ngIf="onboardingClient?.isOnboardingCompleted" class="success-color">Verified</mdb-badge>
                      <mdb-badge *ngIf="!onboardingClient?.isActive" color="black">Archived</mdb-badge>
                      <div class="text-muted small" *ngIf="onboardingClient.clientCreatedDate">
                        Created: {{ onboardingClient.clientCreatedDate | date: "dd MMM yyyy" }} -
                        {{ onboardingClient.clientCreatedDate | daysAgo }}
                      </div>
                    </div>
                    <div class="d-sm-flex" style="justify-content: space-between">
                      <ng-container *ngIf="onboardingClient?.isActive">
                        <ng-container *ngIf="!loadingProfile">
                          <button mdbBtn color="trakly-action" class="relative waves-light btn-sm btn" (click)="onEditProfileClick()">Edit Profile</button>
                        </ng-container>
                        <button mdbBtn class="btn-wealth-restart relative waves-light btn-sm btn" *ngIf="onboardingClient?.isOnboardingCompleted" (click)="restartVerification()">Restart Verification</button>
                        <button mdbBtn class="btn-wealth-arbitrage relative waves-light btn-sm btn" *ngIf="!onboardingClient?.isArbitrageOnboarding" (click)="beginArbitrageProcess()">Begin Arbitrage Onboarding</button>
                      </ng-container>
                      <ng-container *ngIf="canComplete()">
                        <button mdbBtn class="btn-wealth-complete relative waves-light btn-sm btn" (click)="completeWealthProcess()">Complete Wealth Verification</button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-5 p-1">
                    <div class="card mb-2" *ngFor="let category of onboardingClient.onboardingCategoriesAndSteps">
                        <div class="card-header line-item" (click)="onCategoryClick(category)">
                          {{ category.description }}
                          <ng-container *ngIf="category.isCompleted">
                            <span class="icon-success far fa-circle-check"></span>
                          </ng-container>
                          <ng-container *ngIf="category.hasStarted && !category.isCompleted">
                            <span class="icon-incomplete far fa-circle-question"></span>
                          </ng-container>
                        </div>
                        
                        <ng-container *ngIf="stepIsVisible(category)">
                          <div class="card-body my-auto">
                            <ul class="list-group list-group-light">
                              <li
                                class="list-group-item"
                                *ngFor="let step of category.steps"
                              >
                                <app-loading [busy]="step.isUpdating"></app-loading>
                                <div class="d-sm-flex" style="justify-content: space-between">
                                  <ng-container *ngIf="!step.isUpdating">
                                    <ng-container *ngIf="step.emailTemplateId == null">
                                      <div class="form-check line-item text-muted small" *ngIf="!step.isUpdating">
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          name="step_{{ step.id }}"
                                          id="step_id_{{ step.id }}"
                                          [(ngModel)]="step.isCompleted"
                                          (change)="toggleStepUpdate(step)"
                                          [disabled]="onboardingClient.isOnboardingCompleted"
                                        />
                                        <label class="form-check-label" for="step_id_{{ step.id }}">{{ step.description }}</label>
                                      </div>
                                    </ng-container>
                                  </ng-container>
                                  <mdb-badge class="badge-wealth-primary my-auto">ID: {{ step.id }}</mdb-badge>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </ng-container>
                    </div>
                  </div>
                  <div class="col-7 p-1">
                    <div class="card">
                      <div class="card-header">Notes</div>
                      <div class="card-body">
                        <ng-container>
                          <app-create-note [clientId]="selectedClientId" [createdByUserId]="createdByUserId" [isWealth]="true" (noteCreateError)="parseAndDisplayError($event)" (noteCreated)="handleNoteCreated($event)"></app-create-note>
                        </ng-container>
                        <app-notes [newNote]="newNote" [clientId]="selectedClientId" [createdByUserId]="createdByUserId" [isWealth]="true"></app-notes>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
<app-user-profile-modal [selectedUserDetails]="selectedUserFullDetails" [(showModal)]="showUserProfileModal" (onModelChange)="handleUserProfileUpdated($event)"></app-user-profile-modal>
